import React from 'react';
import {TContactInfoProps} from "@/app/[locale]/common/components/ContactInfo/types";
import {Link} from '@/i18n/routing';
import s from './ContactInfo.module.scss';

export const ContactInfo = ({ title, version, Icon }: TContactInfoProps) => {
    const link = version === 'phone' ? 'tel:+639985509738' : 'mailto:edjr23deloria@gmail.com';

    return (
        <Link href={link} className={s.info}>
            <Icon />
            <div className={s.info_content}>
                <label>{ title }</label>
                <span>{ version }</span>
            </div>
        </Link>
    );
};